import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  next(event) {
    const target_tab_button = event.target.closest('.responsive-tabs').querySelector('[data-pc-section="tablist"] [data-p="active"]').nextElementSibling
    let panel_container = target_tab_button.closest('[data-pc-name="tablist"][data-pc-section="root"]').nextElementSibling
    if (panel_container.scrollHeight == panel_container.clientHeight) {
      panel_container = target_tab_button.closest('.overflow-y-auto')
    }
    this.scrollToTop(target_tab_button, panel_container)
  }

  prev(event) {
    const target_tab_button = event.target.closest('.responsive-tabs').querySelector('[data-pc-section="tablist"] [data-p="active"]').previousElementSibling
    let panel_container = target_tab_button.closest('[data-pc-name="tablist"][data-pc-section="root"]').nextElementSibling
    if (panel_container.scrollHeight == panel_container.clientHeight) {
      panel_container = target_tab_button.closest('.overflow-y-auto')
    }
    this.scrollToTop(target_tab_button, panel_container)
  }

  scrollToTop(tab, container) {
    if (tab) tab.click()

    // Sometimes it won't find any parent container with overflow-y-auto
    if (container && container.scrollHeight != container.clientHeight) {
      container.scrollTo({ top: 0 })
      event.preventDefault()
    }
  }
}
